// Chakra imports
import { 
  Box, 
  Flex, 
  Text, 
  useColorModeValue, 
  FormControl, 
  FormLabel, 
  Input, 
  Button, 
  Tabs, 
  TabList, 
  TabPanels, 
  Tab, 
  TabPanel,
  useRadio,
  useRadioGroup,
  HStack,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepNumber,
  StepTitle,
  StepDescription,
  StepSeparator,
  useSteps,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalContent,
  Image,
  useToast,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React, { useState } from "react";
import {useSelector, useDispatch} from 'react-redux';
import request from '@/http/request'
import {setBalance} from '@/store/festures/balanceSlice.js';
import useFetchData from "hooks/fetch";
import { commonFetch } from '@/utils/util'

function RadioCard(props) {
  const { getInputProps, getRadioProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getRadioProps()

  return (
    <Box as='label'>
      <input {...input} />
      <Box
        {...checkbox}
        width={"200px"}
        cursor='pointer'
        borderWidth='1px'
        borderRadius='md'
        boxShadow='md'
        _checked={{
          bg: 'brand.600',
          color: 'white',
          borderColor: 'brand.600',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
        color={'brand.600'}
        px={5}
        py={3}
        borderColor={'brand.600'}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default function Banner(props) {
  const toast = useToast()
  const { banner, avatar, name, job, posts, followers, following } = props;
  const {balanceVal} = useSelector((store)=>store.balance)
  const dispatch = useDispatch()
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const options = [
    {
      label: '充值10,000',
      value: '10000',
      oldValue: '10000',
      discountInfo: '无折扣',
    },
    {
      label: '充值20,000',
      oldValue: '20000',
      value: '20000',
      discountInfo: '无折扣',
    },
    {
      label: '充值50,000',
      oldValue: '50000',
      value: `${50000 * 0.98}`,
      discountInfo: '9.90折',
    },
    {
      label: '充值80,000',
      oldValue: '80000',
      value: `${80000 * 0.98}`,
      discountInfo: '9.90折',
    },
    {
      label: '充值100,000',
      oldValue: '100000',
      value: `${100000 * 0.98}`,
      discountInfo: '9.80折',
    },
    // {
    //   label: '充值500,000',
    //   value: '500000',
    //   discountInfo: '9.50折',
    // }
  ]
  const [customMoney, setCustomMoney] = useState('')
  const [cardVal, setCardVal] = useState('10000')
  const [oldCardVal, setOldCardVal] = useState('10000')
  const [tabIndex, setTabIndex] = useState(0)

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'framework',
    defaultValue: '10000',
    onChange: (e) => {
      setCardVal(e)
      setOldCardVal(options.find(opt => opt.value === e).oldValue)
    },
  })

  const fetchApp = () => {
    return commonFetch({
      url: '/api/mchApps',
      method: 'get',
      data: {
        pageSize: -1
      }
    })
  }

  const group = getRootProps()

  const [isOpen, setIsOpen] = useState(false)

  const [cdkey, setCdkey] = useState('')
  
  const [rechargeModal, setRechargeModal] = useState(false)

  const [recharging, setRecharging] = useState(false)

  const [rechargeImg, setRechargeImg] = useState('')

  const steps = [
    { title: 'First', description: 'Contact Info' },
    { title: 'Second', description: 'Date & Time' },
    { title: 'Third', description: 'Select Rooms' },
  ]

  const { activeStep } = useSteps({
    index: -1,
    count: steps.length,
  })

  const confirmRecharge = (money, oldVale) => {
    setRecharging(true)
    fetchApp().then(res => {
      return {
        appId: res.records[0].appId,
        mchOrderNo: 'M' + new Date().getTime() + Math.floor(Math.random() * (9999 - 1000) + 1000)
      }
    }).then((data) => {
      request.request({
        url: '/api/balance/recharge',
        method: 'post',
        data: {
          ...data,
          rechargeAmount: oldVale || money,
          wayCode: "WX_NATIVE",
          amount: money,
          payDataType: "codeImgUrl",
          authCode: "",
          divisionMode: 0,
          orderTitle: "余额充值"
        }
      }).then(res => {
        // alert(res)
        // setRechargeImg(res.payData)
        // setRechargeModal(true)
        // console.log('res', res)
        showModal('WX_NATIVE', res)
      }).catch(() => {
      })
    }).finally(() => {
      setRecharging(false)
    })
  }

  const completeRecharge = () => {
    request.request({
      url: '/api/balance/detail',
      method: 'get'
    }).then(res => {
      // alert(res)
      dispatch(setBalance(res.toFixed(2)))
    }).catch(() => {})
    setRechargeModal(false)
  }

  // 支付订单webSocket对象
  const [payOrderWebSocket, setPayOrderWebSocket] = useState(null)
  // 接口返回数据包
  const [apiRes, setApiRes] = useState(false)
  // 微信二维码图片是否展示
  const [wxApp, setWxApp] = useState(false)
  // 支付宝二维码图片是否展示
  const [aliApp, setAliApp] = useState(false)
  const [visible, setVisible] = useState(false)
  // 二维码底部描述文字
  const [payText, setPayText] = useState('')
  // 提示框开关
  const [tipModalOff, setTipModalOff] = useState(false)
  // 提示框内容
  const [tipContent, setTipContent] = useState('')
  // 提示框标题
  const [tipTxt, setTipTxt] = useState('')
  // 轮训定时器
  const [timer, setTimer] = useState(null)

  const rotationTraining = (orderId, payOrderId) => {
    commonFetch({
      url: `/api/consumption/pay/${payOrderId}`,
      method: 'get',
    }, toast).then(res => {
      if (res.state === 2) {
        clearTimeout(timer)
        setRechargeModal(false)

        setTipContent('支付成功，请稍后查看余额')
        setTipModalOff(true)
      } else {
        const timer = setTimeout(() => {
          rotationTraining(orderId, payOrderId)
        }, 1000)
        setTimer(timer)
      }
    })
  }

  // 二维码以及条码弹窗
  const showModal = (wayCode, apiRes) => {
    // 关闭定时器
    clearInterval(timer)

    setApiRes(apiRes)
    setWxApp(false)
    setAliApp(false)
    setVisible(true)

    // 根据不同的支付方式，展示不同的信息
    setPayText('')
    if (wayCode === 'WX_NATIVE' || wayCode === 'WX_JSAPI') { // 微信二维码
      setWxApp(true)
      setPayText('请使用微信"扫一扫"扫码支付')
    } else if (wayCode === 'ALI_QR' || wayCode === 'ALI_JSAPI' || wayCode === 'ALI_OC') { // 支付宝二维码
      setAliApp(true)
      setPayText('请使用支付宝"扫一扫"扫码支付')
    } else if (wayCode === 'QR_CASHIER') { // 聚合支付二维码
      setWxApp(true)
      setAliApp(true)
      setPayText('支持微信、支付宝扫码')
    }

    // 此处判断接口中返回的orderState，值为0，1 代表支付中，直接放行无需处理，2 成功 3 失败
    if (apiRes.orderState === 2 || apiRes.orderState === 3) {
      if (apiRes.orderState === 2) {
        handleClose()
        // const succModal = that.$infoBox.modalSuccess('支付成功', <div>2s后自动关闭...</div>)
        setTipContent('支付成功')
        setTipModalOff(true)
        // setTimeout(() => { succModal.destroy() }, 2000)
      } else if (apiRes.orderState === 3) {
        handleClose()
        // that.$emit('closeBarCode') // 关闭条码框
        // that.$infoBox.modalError('支付失败', <div><div>错误码：{ apiRes.errCode}</div>
        // <div>错误信息：{ apiRes.errMsg}</div></div>)
        setTipContent(<div>
            <div>支付失败</div>
            <div>错误码：{ apiRes.errCode}</div>
            <div>错误信息：{ apiRes.errMsg}</div>
          </div>)
        setTipModalOff(true)
      }
      return
    }

    // h5 或者 wap
    if (wayCode === 'WX_H5' || wayCode === 'ALI_WAP') {
      // this.payText = '请复制链接到手机端打开'
      setPayText('请复制链接到手机端打开')
    } else {
    // 跳转到PC网站
      if (apiRes.payDataType === 'payurl') {
        window.open(apiRes.payData)
      }
    }
    // 如果上面未关闭条码框，则代表进入webScoket，那么先在此处关闭条码框
    // that.$emit('closeBarCode') // 关闭条码框
    // 监听响应结果
    // this.payOrderWebSocket = new ReconnectingWebSocket(getWebSocketPrefix() + '/api/anon/ws/payOrder/' + apiRes.payOrderId + '/' + new Date().getTime())
    // this.payOrderWebSocket.onopen = () => {}
    // this.payOrderWebSocket.onmessage = (msgObject) => {
    //   const resMsgObject = JSON.parse(msgObject.data)
    //   if (resMsgObject.state === 2) {
    //     that.handleClose()
    //     const succModal = that.$infoBox.modalSuccess('支付成功', <div>2s后自动关闭...</div>)
    //     setTimeout(() => { succModal.destroy() }, 2000)
    //   } else {
    //     that.handleClose()
    //     that.$infoBox.modalError('支付失败', <div><div>错误码：{ apiRes.errCode}</div>
    //     <div>错误信息：{ apiRes.errMsg}</div></div>)
    //   }
    // }

    // 开始定时器，每隔5s请求一次订单状态
    rotationTraining(apiRes.mchOrderNo, apiRes.payOrderId)

    setRechargeImg(apiRes.payData)
    setRechargeModal(true)
  }

  const handleClose = (e) => {
    if (payOrderWebSocket) {
      payOrderWebSocket.close()
    }
    setVisible(false)
  }

  return (
    <Flex mb={{ base: "0px", lg: "0" }} align='center' flexDirection={'column'}> 
      <Box
        bg={`url(${banner})`}
        bgSize='cover'
        borderRadius='16px'
        h='180px'
        w='100%'
      />
      <Text color={textColorPrimary} fontWeight='bold' fontSize='40' mt='10px' mb="10px">
        余额：¥{balanceVal}
      </Text>
      <Text color={textColorSecondary} fontWeight='bold' fontSize='18' mb="20px">
        兑换余额
      </Text>

      <Flex align={'flex-start'} w={'100%'}>
        <Box flex={1}>
          <FormControl>
            <FormLabel>兑换码</FormLabel>
            <Input value={cdkey} placeholder="请输入兑换码" onChange={e => setCdkey(e.target.value)} />
          </FormControl>
          
          <Flex justifyContent={'flex-start'} width={'100%'} mt="10px">
            <Button variant="brand" onClick={() => {
              toast({
                title: cdkey ? '兑换码无效' : '请输入兑换码',
                status: 'error',
                isClosable: true,
              })
            }}>兑换</Button>
          </Flex>

          <Flex width="100%" mt="20px">
            <Tabs 
              index={tabIndex} 
              width={"100%"} 
              size='md' 
              ariant='soft-rounded' 
              colorScheme='green'
              onChange={(index) => {
                setTabIndex(index)
              }}
            >
              <TabList>
                <Tab _selected={{ color: 'brand.500', borderColor: 'brand.500' }}>固定金额</Tab>
                <Tab _selected={{ color: 'brand.500', borderColor: 'brand.500' }}>自定义金额</Tab>
                <Tab _selected={{ color: 'brand.500', borderColor: 'brand.500' }}>对公转账</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <HStack {...group} width={'100%'}>
                    <Flex gap={"10px"} flexWrap={'wrap'} width={'100%'}>
                      {options.map((opt) => {
                          const radio = getRadioProps({ value: opt.value })
                          return (
                            <RadioCard key={opt.value} {...radio}>
                              <Flex direction={'column'} justifyContent={'center'} alignItems={'center'}>
                                <Text fontSize='20' fontWeight={500}>{ opt.label }</Text>
                                <Text fontSize='16' mt="10px">{ opt.discountInfo }</Text>
                              </Flex>
                            </RadioCard>
                          )
                        })}
                    </Flex>
                  </HStack>
                  <Flex justifyContent={'flex-start'} alignItems={'flex-start'} direction={'column'} mt="20px">
                    <Text fontWeight={500} fontSize={20} mb="10px">充值金额：¥{oldCardVal}</Text>
                    <Text fontWeight={500} fontSize={20} mb="10px">实际付款：¥{ cardVal}</Text>
                    <Box
                      cursor='pointer'
                      borderWidth='1px'
                      borderRadius='md'
                      boxShadow='md'
                      color={'#fff'}
                      // bac="brand.600"
                      px={5}
                      py={3}
                      borderColor={'brand.600'}
                      background={'brand.600'}
                    >
                      <Flex alignItems={'center'} justifyContent={'center'}>
                        <svg t="1736324289198" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4319" width="20" height="20"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" fill="#ffffff" p-id="4320"></path></svg>
                        <Text ml={'5px'}>微信支付</Text>
                      </Flex>
                    </Box>
                    <Button 
                      variant="brand"
                      fontSize='sm'
                      fontWeight='500'
                      w='100px'
                      h='50'
                      mb='24px'
                      mt="20px"
                      borderRadius={'10px'}
                      isLoading={recharging}
                      loadingText="充值中"
                      // onClick={() => confirmRecharge(cardVal, oldCardVal)}
                      onClick={() => confirmRecharge(cardVal, oldCardVal)}
                    >
                      充值
                    </Button>
                  </Flex>
                </TabPanel>
                <TabPanel>
                  <FormControl>
                    <FormLabel>金额</FormLabel>
                    <Input value={customMoney} type="number" placeholder="请输入金额"  onChange={e => setCustomMoney(e.target.value)} />
                  </FormControl>
                  <Flex direction={'column'} justifyItems={'flex-start'} align={'flex-start'} mt="20px">
                    <Text fontWeight={500} fontSize={20} mb="20px">充值金额：¥{customMoney || 0}</Text>
                    <Text fontWeight={500} fontSize={20} mb="20px">实际付款：¥{customMoney || 0}</Text>
                    <Box
                      cursor='pointer'
                      borderWidth='1px'
                      borderRadius='md'
                      boxShadow='md'
                      color={'#fff'}
                      // bac
                      px={5}
                      py={3}
                      borderColor={'brand.600'}
                      background={'brand.600'}
                    >
                      <Flex alignItems={'center'} justifyContent={'center'}>
                        <svg t="1736324289198" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4319" width="20" height="20"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" fill="#ffffff" p-id="4320"></path></svg>
                        <Text ml={'5px'}>微信支付</Text>
                      </Flex>
                    </Box>
                  </Flex>
                  <Button 
                      variant="brand"
                      fontSize='sm'
                      fontWeight='500'
                      w='100px'
                      h='50'
                      mb='24px'
                      mt="20px"
                      borderRadius={'10px'}
                      onClick={() => customMoney && confirmRecharge(customMoney)}
                    >
                      充值
                    </Button>
                </TabPanel>
                <TabPanel>
                  <Stepper index={activeStep} orientation='vertical' height='400px' gap='0'>
                    <Step>
                      <StepIndicator>
                        <StepStatus
                          complete={<StepIcon />}
                          incomplete={<StepNumber />}
                          active={<StepNumber />}
                        />
                      </StepIndicator>

                      <Box flexShrink='0' flex={1} minWidth={0}>
                        <StepTitle>
                          <Box fontSize={18} fontWeight={500} mt="5px">确认银行卡开户名</Box>
                        </StepTitle>
                        <Flex direction={'column'}>
                          <Box width={'100%'}>
                            <Box fontSize={16} color={'gray.500'} mb="10px" lineHeight={'30px'}>
                              1.您可以选择使用以下银行卡名义进行汇款。<br/>
                              2.为了防范潜在的欺诈和洗钱风险，对于使用与实名认证信息不符的银行账户进行汇款的情况，我们将进行进一步审核和审慎评估，并有权拒绝涉及异常情况的相关汇款。
                            </Box>
                          </Box>
                          {/* <Flex>
                            <Button variant="outline" borderRadius={"4px"} mb={"30px"} borderColor={"gray.400"}>殷志杰</Button>
                          </Flex> */}
                        </Flex>
                      </Box>

                      <StepSeparator />
                    </Step>

                    <Step>
                      <StepIndicator>
                        <StepStatus
                          complete={<StepIcon />}
                          incomplete={<StepNumber />}
                          active={<StepNumber />}
                        />
                      </StepIndicator>

                      <Box flexShrink='0' flex={1} minWidth={0}>
                        <StepTitle>
                          <Box fontSize={18} fontWeight={500} mt="5px">进行汇款</Box>
                        </StepTitle>
                        <Box fontSize={16} color={'gray.500'} mb="10px" lineHeight={'30px'}>
                          我们对每个账号都会分配一个唯一的银行专属汇款账号，请妥善保管，切勿泄露给他人；如果您尚未获得专属汇款账号，请点击下方按钮获取。
                        </Box>
                        <StepDescription width="100%">
                          <Button variant="brand" borderRadius={"4px"} mb={"30px"} borderColor={"gray.400"} onClick={() => setIsOpen(true)}>获取专属汇款账号</Button>

                          <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                            <ModalOverlay />
                            <ModalContent w="500px" maxWidth={'100vw'}>
                              <ModalHeader>汇款信息</ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                  <Box w="100%" padding={'20px'} background={"gray.100"} width={"100%"} m={"15px 0"}>
                                    <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>您的专属汇款账号</Flex>
                                    <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>
                                      <Text width={"130px"} mr="40px">收款人名称</Text>
                                      <Text flex={1}>深圳市特伟欣科技有限公司</Text>
                                    </Flex>
                                    <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>
                                      <Text width={"130px"} mr="40px">收款人账号</Text>
                                      <Text flex={1}>4000 0312 0920 0621 593</Text>
                                    </Flex>
                                    <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>
                                      <Text width={"130px"} mr="40px">开户行名称</Text>
                                      <Text flex={1}>中国工商银行深圳翠竹北支行</Text>
                                    </Flex>
                                    {/* <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>
                                      <Text width={"130px"} mr="40px">分行代码</Text>
                                      <Text flex={1}>308331012079</Text>
                                    </Flex>
                                    <Flex fontSize={"18px"} fontWeight={"500"} mb="10px" color={'gray.600'}>
                                      <Text width={"130px"} mr="40px">币种</Text>
                                      <Text flex={1}>CNY</Text>
                                    </Flex> */}
                                  </Box>
                              {/* <Box fontSize={16} color={'gray.500'} mb="10px" lineHeight={'30px'}>
                                每个云账号会对应分配唯一的银行专属汇款账号，获取后请勿告知他人，
                                您还未获取专属汇款账号，请点击下方按钮获取。
                              </Box> */}
                              </ModalBody>

                              <ModalFooter>
                                <Button colorScheme='blue' mr={3} onClick={() => setIsOpen(false)}>
                                  确定
                                </Button>
                              </ModalFooter>
                            </ModalContent>
                          </Modal>
                          
                        </StepDescription>
                      </Box>

                      <StepSeparator />
                    </Step>

                    <Step>
                      <StepIndicator>
                        <StepStatus
                          complete={<StepIcon />}
                          incomplete={<StepNumber />}
                          active={<StepNumber />}
                        />
                      </StepIndicator>

                      <Box flexShrink='0' flex={1} minWidth={0}>
                        <StepTitle>
                          <Box fontSize={18} fontWeight={500} mt="5px">等待汇款到账后，认领充值到您的账户中，如有疑问请联系，微信：【YONGXIN021】</Box>
                        </StepTitle>
                        {/* <StepDescription width="100%">
                          <Box fontSize={16} color={'gray.500'} mb="10px" lineHeight={'30px'}>
                            1.在汇款户名，账号信息正确的情况下，一般 30分钟 后到账，请在30分钟后至 汇款认领 页面查询汇款记录。<br/>
                            2.汇款到账后，根据不同的汇款方式，需要您进行认领处理:<br/>
                              2.1 向您的专属汇款账号汇款，汇款到账后，系统将自动认领至您的阿里云账户;<br/>
                              2.2 非专属汇款账号汇款(包括向579***702账户汇款或阿里云其他公司主体的汇款)，专属汇款账号填写错误的汇款，需要您至 汇款认领 页面发起人工认领.<br/>
                              3.认领充值到您阿里云账户后，系统将通过短信通知您充值结果。
                          </Box>
                        </StepDescription> */}
                      </Box>

                      <StepSeparator />
                    </Step>
                  </Stepper>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
          {/* <Text color={textColorSecondary} fontSize='sm'>
            {'暂无作用' || job}
          </Text> */}
          {/* <WithdrawModal /> */}
          {/* <Flex width={'80%'}>
            <Card p='30px 15px'>
              <Flex w='100%' mx='auto' justifyContent={'space-between'}>
                <Flex mx='auto' me='60px' align='center' direction='column' flex={1}>
                  <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                    惠州市XX有限公司
                  </Text>
                  <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                    Company
                  </Text>
                </Flex>
                <div style={{ width: '1px', height: '100%', backgroundColor: 'rgba(135, 140, 189, 0.3)' }}></div>
                <Flex mx='auto' me='60px' align='center' direction='column'>
                  <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                    ¥100
                  </Text>
                  <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                    余额
                  </Text>
                </Flex>
                <div style={{ width: '1px', height: '100%', backgroundColor: 'rgba(135, 140, 189, 0.3)' }}></div>
                <Flex mx='auto' align='center' direction='column' flex={1}>
                  <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
                    416467726@qq.com
                  </Text>
                  <Text color={textColorSecondary} fontSize='sm' fontWeight='400' mt="10px">
                    Email
                  </Text>
                </Flex>
              </Flex>
            </Card>
          </Flex> */}
        </Box>
        <Card width={"47%"} ml={"30px"}>
          <Box lineHeight={"30px"} fontSize={"16px"} color={"gray.600"}>
          尊敬的客户，<br/>
          &emsp;&emsp;感谢您选择使用我们的支付平台进行线上支付。为了明确手续费收取标准，特此向您说明：<br/>
          &emsp;&emsp;收费标准如下（账户开启之日起一年内）：<br/>
          &emsp;&emsp;&emsp;&emsp;①&emsp;3亿元（含）以内：手续费为0.6%；<br/>
          &emsp;&emsp;&emsp;&emsp;②&emsp;超过3亿元至5亿元（含）：手续费为0.55%；<br/>
          &emsp;&emsp;&emsp;&emsp;③&emsp;超过5亿元至10亿元（含）：手续费为0.48%；<br/>
          &emsp;&emsp;&emsp;&emsp;④&emsp;超过10亿元：手续费为0.42%；<br/>
          &emsp;&emsp;&emsp;&emsp;⑤&emsp;当手续费金额低于0.01元时，按0.01元计算。<br/>
          &emsp;&emsp;手续费将根据您的交易金额自动计算并收取，具体金额以实际交易为准。<br/>
          &emsp;&emsp;我方承诺，仅对您的资金做保驾护航作用，不会实际干涉资金数据。<br/>
          &emsp;&emsp;如有任何关于手续费收取或交易金额范围的疑问，请随时联系我们的客户服务团队以获取进一步帮助。<br/>
          &emsp;&emsp;再次感谢您选择我们的服务，我们期待为您提供优质的支付体验。<br/><br/>
          <Flex justifyContent={'flex-end'}>【MoonBamboo支付平台】</Flex>
          <Flex justifyContent={'flex-end'}>微信联系方式：YONGXIN021</Flex><br/>
          </Box>
        </Card>
      </Flex>

      <Modal isOpen={rechargeModal} onClose={() => {
        clearTimeout(timer)
        setRechargeModal(false)
      }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>充值</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex align={'center'} direction={'column'} justify={'center'} mb="10px">
              <Box>
                <Text color={"gray.800"} fontWeight={500} mt={"-5px"} mb="10px">使用微信扫一扫完成支付</Text>
              </Box>
              <Image src={rechargeImg} width={"150px"} h={"150px"} />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button variant='ghost' onClick={() => {
              clearTimeout(timer)
              setRechargeModal(false)
            }}>关闭</Button>
            {/* <Button variant="brand" mr={3} onClick={completeRecharge}>
              我已充值
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={tipModalOff} onClose={() => setTipModalOff(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{tipTxt || '提示'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {tipContent}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={() => {
              completeRecharge()
              setTipModalOff(false)
            }}>
              确定
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
